import { buildLocalizedPath, type EnterHomeLocale } from '@/contexts/i18n/utils';

/** 公开 Contact Sales 入口；不在 Home 注册第二条路由。 */
export const CONTACT_SALE_PATH = '/contact-sales';

/** 产品区打开 Contact Sales：同站的本地化公开页，`from` 标记入口来源。 */
export function buildContactSalesHref(locale: EnterHomeLocale, from: string): string {
    const params = new URLSearchParams({ from });
    return `${buildLocalizedPath(locale, CONTACT_SALE_PATH)}?${params.toString()}`;
}
